import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import HeroSection from "../components/HeroSection";
import SearchSection from "../components/SearchSection";
import Accommodations from "../components/Accommodations";
import GallerySection from "../components/GallerySection";
import CampaignSection from "../components/CampaignSection";
import Footer from "../components/Footer";

export default function Home() {
  const [activeMenu, setActiveMenu] = useState("home");
  const [language, setLanguage] = useState(
    localStorage.getItem("language") || "EN",
  );
  const [darkMode, setDarkMode] = useState(
    localStorage.getItem("darkMode") === "true",
  );
  const [searchParams, setSearchParams] = useState(null);

  useEffect(() => {
    localStorage.setItem("language", language);
    localStorage.setItem("darkMode", darkMode.toString());
  }, [language, darkMode]);

  const toggleDarkMode = () => setDarkMode((prev) => !prev);
  const switchLanguage = () =>
    setLanguage((prev) => (prev === "EN" ? "ID" : "EN"));

  const handleNavLinkClick = (menu) => {
    const menuId = menu.toLowerCase().replace(/\s+/g, "-");
    setActiveMenu(menuId);
    const element = document.getElementById(menuId);
    if (element) element.scrollIntoView({ behavior: "smooth" });
  };

  const scrollToSearch = () => {
    const searchSection = document.getElementById("search-section");
    if (searchSection) searchSection.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div
      className={`min-vh-100 ${darkMode ? "bg-dark text-white" : "bg-light text-dark"}`}
    >
      <Header
        language={language}
        switchLanguage={switchLanguage}
        darkMode={darkMode}
        toggleDarkMode={toggleDarkMode}
        activeMenu={activeMenu}
        handleNavLinkClick={handleNavLinkClick}
      />
      <HeroSection language={language} scrollToSearch={scrollToSearch} />
      <SearchSection onSearch={setSearchParams} />
      <Accommodations searchParams={searchParams} />
      <CampaignSection language={language} />
      <GallerySection language={language} />
      <Footer />
    </div>
  );
}
